export default { sha: '992f4d7b68b71dd1693a7758226082e05e48e8a1', buildNumber: 'undefined' }
